// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"b4fcd5e6","239":"14e395a0","455":"c482acf8"}[chunkId] + ".chunk.js";
};